import {where} from "firebase/firestore";
import dayjs from "dayjs";
import 'dayjs/locale/es'
import {contarWheresSuma} from "../../Servicios/BD/Contadores/contarWheresSuma";
import {obtenerFechasIniFInAno} from "../Funciones/obtenerFechasIniFInAno";
import {FECHACHECKIN} from "../Constantes";


export const arrConteoColAnoAtrasSuma = async ({coleccion, year = 2025, propiedad, wheres = [], numHabitaciones}) => {
    dayjs.locale('es')
    // obtener arr de timestamp inicio mes, fin mes
    let arrFechasInicioFin = obtenerFechasIniFInAno(year)

    let arrPromesas = []
    for (let i = 0; i < arrFechasInicioFin.length; i++) {
        arrPromesas.push(docmentosFecha(arrFechasInicioFin[i], coleccion, propiedad, wheres))
    }

    let arr = await Promise.all(arrPromesas)

    let arrOcupacion = []
    let fechaFinMesActual = new Date(new Date().getFullYear(), new Date().getMonth() + 2, -1, 0, 0, 0)
    for (let i = 0; i < arr.length; i++) {

        let dato = arr[i]


        if (dato.fechaFin <= fechaFinMesActual) {
            let obj = {
                nombre: dato.nombre,
                cantidad: ((dato.cantidad * 100) / (numHabitaciones * 30)).toFixed(2)
            }

            arrOcupacion.push(obj)
        }


    }


    return arrOcupacion

}

const docmentosFecha = async (fechas, coleccion, propiedad, wheres) => {

    dayjs.locale('es')
    let wheres_ = [where(FECHACHECKIN, '>=', fechas.fechaInicio), where(FECHACHECKIN, '<=', fechas.fechaFin), ...wheres]

    let result = await contarWheresSuma({coleccion: coleccion, wheres: wheres_, propiedad: propiedad})

    return {
        nombre: dayjs(fechas.fechaInicio).format('MMMM').charAt(0).toUpperCase() + dayjs(fechas.fechaInicio).format('MMMM').slice(1),
        cantidad: result.data,
        fechaFin: fechas.fechaFin
    }

}